import { GameVars } from "../../../GameVars";

export class TimerLabel extends Phaser.GameObjects.Container {

    private timeLabel: Phaser.GameObjects.Text;
    private pulseImage: Phaser.GameObjects.Image;
    private pulsing: boolean;
    private f: number;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.pulsing = false;
        this.f = 0;

        this.scaleY = GameVars.scaleY;

        const spaceBetweenTimeLabelAndSecondsLabel = 10;

        this.pulseImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "alarm_light");
        this.pulseImage.setOrigin(.5);
        this.pulseImage.setAlpha(0);
        this.pulseImage.setScale(.01);
        this.add(this.pulseImage);

        this.timeLabel = new Phaser.GameObjects.Text(this.scene, 0, -30, GameVars.time.toString(), { fontFamily: "Sarpanch-Black", fontSize: "50px", color: "#00bbfb" });
        this.timeLabel.setOrigin(1, .5);
        this.timeLabel.x = this.timeLabel.width * .5;
        this.timeLabel.setShadow(0, 0, "#6edbff", 5, true, true);
        this.add(this.timeLabel);

        const secondsLabel = new Phaser.GameObjects.Text(this.scene, 0, -8, "s.", { fontFamily: "Sarpanch-Black", fontSize: "32px", color: "#00bbfb" });
        secondsLabel.setOrigin(0, 1);
        secondsLabel.x = this.timeLabel.x + spaceBetweenTimeLabelAndSecondsLabel;
        secondsLabel.setShadow(0, 0, "#6edbff", 4, true, true);
        this.add(secondsLabel);

        const timeIcon = new Phaser.GameObjects.Image(this.scene, 0, -9, "texture_atlas_1", "icon_time");
        timeIcon.setOrigin(0, 1);
        timeIcon.setScale(.7);
        timeIcon.x = this.timeLabel.x + secondsLabel.width + spaceBetweenTimeLabelAndSecondsLabel;
        this.add(timeIcon);

        this.scene.sys.updateList.add(this);
    }

    public preUpdate(time: number, delta: number): void {

        if (GameVars.pause) {
            return;
        }

        if (!this.pulsing && GameVars.time < 10 && GameVars.time > 0) {
            this.pulsing = true;
            this.f = 0;
        }

        if (this.pulsing) {

            this.f += delta;

            if (this.f >= 500) {

                this.f = 0;

                if (this.pulseImage.alpha === 0) {

                    this.pulseImage.setScale(.01);
                    this.pulseImage.setAlpha(1);

                    this.scene.tweens.add({
                        targets: [this.pulseImage],
                        scaleX: 10,
                        scaleY: 10,
                        alpha: 0,
                        ease: Phaser.Math.Easing.Cubic.Out,
                        duration: 450
                    });
                }
            }

            if (GameVars.time <= 0 || GameVars.time > 4) {
                this.pulsing = false;
            }
        }
    }

    public updateTimer(): void {

        this.timeLabel.text = GameVars.time.toString();
    }   
}
